import React from 'react';

import PropTypes from 'prop-types';

import { Script } from '@techstyle/react-marketing';

export default function PaypalSnippet({ onReady }) {
  return (
    <>
      <Script
        skipServerRender
        src="https://www.paypalobjects.com/api/checkout.js"
        globalScriptKey="paypal-checkout"
        data-version-4
      />
      <Script
        skipServerRender
        src="https://js.braintreegateway.com/web/3.55.0/js/client.min.js"
        globalScriptKey="braintree-client"
        onReady={onReady}
      />
      <Script
        skipServerRender
        src="https://js.braintreegateway.com/web/3.55.0/js/paypal-checkout.min.js"
        globalScriptKey="braintree-paypal-checkout"
      />
      <Script
        skipServerRender
        src="https://js.braintreegateway.com/web/3.55.0/js/data-collector.min.js"
        globalScriptKey="braintree-data-collector"
      />
    </>
  );
}

PaypalSnippet.propTypes = {
  onReady: PropTypes.func.isRequired,
};
